import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);
import { provideRouter } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { fr_FR, provideNzI18n, NzI18nInterface } from 'ng-zorro-antd/i18n';

const customFrLocale: NzI18nInterface = {
  ...fr_FR,
  DatePicker: {
    ...fr_FR.DatePicker,
    lang: {
      ...fr_FR.DatePicker.lang,
      rangeQuarterPlaceholder: ['Trimestre début', 'Trimestre fin']
    }
  }
};
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { importProvidersFrom } from '@angular/core';
import { BASE_PATH, Configuration } from '@crm/api';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { icons } from './icons-provider';
import { authInterceptor } from './auth/auth.interceptor';
import { AuthService } from './auth/auth.service';
import { readAccessToken } from './auth/token-storage';
import { PageViewTracker } from './shared/page-view-tracker';


function apiInitializer() {
  return environment.apiUrl;
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideNzIcons(icons),
    provideNzI18n(customFrLocale),
    provideCharts(withDefaultRegisterables()),
    importProvidersFrom(NzModalModule),
    provideHttpClient(withInterceptors([authInterceptor])),
    // Renew the session before the first route resolves, so a returning user whose access token
    // has expired lands signed in rather than on the login page.
    provideAppInitializer(() => firstValueFrom(inject(AuthService).restoreSession())),
    // Compte les pages consultées, pour le rapport mensuel d'utilisation.
    provideAppInitializer(() => inject(PageViewTracker).start()),
    {
      provide: BASE_PATH,
      useFactory: apiInitializer,
    },
    {
      provide: Configuration,
      useValue: new Configuration({
        credentials: {
          Bearer: () => readAccessToken() || undefined
        }
      })
    }
  ],
};
